import type { TextareaHTMLAttributes } from 'react';
import { forwardRef } from 'react';

import { DefaultFormFieldLayout } from '../DefaultFormFieldLayout/DefaultFormFieldLayout';
import type { HelperText } from '../FormFieldHelperText/FormFieldHelperText';

export type CoreFormFieldTextAreaProps = {
  inputProps: TextareaHTMLAttributes<HTMLTextAreaElement>;
  label?: React.ReactNode;
  error?: string;
  helperText?: HelperText;
  inline?: boolean;
};

export const CoreFormFieldTextArea = forwardRef(function _CoreFormFieldTextArea(
  { error, helperText, inline, inputProps, label }: CoreFormFieldTextAreaProps,
  ref: React.Ref<HTMLTextAreaElement>
) {
  return (
    <DefaultFormFieldLayout
      label={label}
      error={error}
      inputId={inputProps.id}
      inline={inline}
      helperText={helperText}
    >
      <div className="flex items-center gap-2">
        <textarea
          data-testid={inputProps.id}
          className={`block w-full rounded-md shadow-sm disabled:cursor-not-allowed disabled:text-gray-400 sm:text-sm ${
            error
              ? 'border-red-300 focus:border-red-300 focus:ring-red-500'
              : 'focus:border-indigo-500 focus:ring-indigo-500 border-gray-300'
          }`}
          {...inputProps}
          ref={ref}
        />
      </div>
    </DefaultFormFieldLayout>
  );
});
